var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-10"},[_c('v-row',{staticClass:"mb-3",attrs:{"justify":"center","align":"start","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12","lg":"12"}},[_c('v-card',{staticStyle:{"min-height":"100vh"}},[_c('v-card-title',[_vm._v(" Tutoriais ")]),_c('span',{staticStyle:{"margin-left":"16px"}},[_vm._v("Em breve...")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }